module.exports = __webpack_public_path__ + "static/media/overpass-extralight-italic.5a7110dd.eot";